/* components/SiteHeader.ts
Global Site Header

Example
<site-header>
    Site header content here
</site-header>
*/

import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class SiteHeader extends ThemeComponent {
    addListener: (() => void)|null = null;
    addScrollListener: (() => void)|null = null;

    private mobileMenu: HTMLDivElement|null = null;
    private siteHeader: HTMLDivElement|null = null;
    private announcementBanner: HTMLDivElement|null = null;
    private miniNav: HTMLDivElement|null = null;
    private currentScrollPosition: number = 0;

    init() {
        this.announcementBanner = document.querySelector('.js-announcement-banner');
        this.miniNav = document.querySelector('.js-mini-nav');

        if (!this.addListener) {
            this.addListener = () => this.setMenuPosition();
        }

        if (!this.addScrollListener) {
            this.addScrollListener = () => this.hideElements();
        }

        window.addEventListener('load', this.addListener);
        window.addEventListener('resize', this.addListener);
        window.addEventListener('scroll', this.addScrollListener);
    }

    setMenuPosition() {
        const breakpoint = window.matchMedia(`(max-width: 1024px)`);

        if (!breakpoint.matches) { return; }

        this.mobileMenu = document.querySelector('.js-mobile-menu');
        this.siteHeader = document.querySelector('.js-site-header');

        if (this.mobileMenu && this.siteHeader) {
            this.mobileMenu.style.top = `${this.siteHeader.offsetHeight}px`;
            this.mobileMenu.style.height = `calc(100% - ${this.siteHeader.offsetHeight}px)`;
        }
    }

    hideElements() {
        if (!this.announcementBanner) { return; }
        if (!this.miniNav) { return; }

        if (document.body.getBoundingClientRect().top < this.currentScrollPosition) {
            this.announcementBanner.classList.add('is-hidden');
            this.miniNav.classList.add('is-hidden');
            document.querySelector('body')?.classList.add('scrolled-down');
        } else {
            this.announcementBanner.classList.remove('is-hidden');
            this.miniNav.classList.remove('is-hidden');
            document.querySelector('body')?.classList.remove('scrolled-down');
        }

        this.currentScrollPosition = document.body.getBoundingClientRect().top;
    }
}
